import React, { useState } from "react";
import { useBiblo } from "../../hooks/Biblo.hook";
import { View } from "react-native";
import { Typography, TypographySize } from "../Typography.component";
import { getTextStyles, getViewStyles } from "../../helpers/getStyles.helper";
import { ErrorBoundary } from "../ErrorBoundary.component";
import { ReaderControls } from "./ReaderControls.component";
import { useItemProps } from "../../hooks/ItemProps.hook";
import { ReaderControlsToggle } from "./ReaderControlsToggle.component";
export const ReaderItem = /*#__PURE__*/React.memo(props => {
  const [controlsShown, setControlsShown] = useState(false);
  const {
    readerOptions,
    defaultStyles,
    disableDefaultStyles: disabledDefaultStylesGlobal,
    textParser
  } = useBiblo();
  const {
    getPropsForComponent,
    propsFromItem,
    updatePropFromItem
  } = useItemProps();
  const Item = readerOptions.item || View;
  const ItemTitleComponent = readerOptions.itemTitleComponent || View;
  const ItemDescriptionComponent = readerOptions.itemDescriptionComponent || View;
  const ItemComponentWrapper = props.Wrapper || readerOptions.itemComponentWrapper || View;
  const disableDefaultStyles = disabledDefaultStylesGlobal || readerOptions.disableDefaultStyles;
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    type: "item"
  }, /*#__PURE__*/React.createElement(Item, {
    index: props.index,
    isFirst: props.isFirst,
    isLast: props.isLast,
    bio: props.bio,
    controlsShown: controlsShown,
    setControlsShown: setControlsShown,
    title: props.title,
    originalTitle: props.originalTitle,
    description: props.description,
    style: getViewStyles(readerOptions.itemStyle, {
      marginVertical: defaultStyles.spacing
    }, disableDefaultStyles)
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      flexDirection: "row",
      justifyContent: "space-between"
    }
  }, props.title && /*#__PURE__*/React.createElement(ErrorBoundary, {
    type: "itemTitleComponent"
  }, /*#__PURE__*/React.createElement(ItemTitleComponent, {
    title: props.title,
    originalTitle: props.originalTitle,
    style: getViewStyles(readerOptions.itemTitleStyle, {
      paddingHorizontal: defaultStyles.spacing
    }, disableDefaultStyles)
  }, /*#__PURE__*/React.createElement(ErrorBoundary, {
    type: "the title"
  }, /*#__PURE__*/React.createElement(Typography, {
    bold: true,
    style: readerOptions.itemTitleTextStyle,
    disableDefaultStyles: disableDefaultStyles
  }, textParser(props.title, {
    type: "title",
    screen: "reader",
    scope: "item",
    style: getTextStyles(readerOptions.itemTitleTextStyle, {
      fontWeight: "bold"
    }, disableDefaultStyles)
  }))))), readerOptions.itemControlsToggleHidden === false && Object.keys(propsFromItem).length > 0 && /*#__PURE__*/React.createElement(View, {
    style: {
      alignSelf: "center",
      marginRight: defaultStyles.spacing
    }
  }, /*#__PURE__*/React.createElement(ReaderControlsToggle, {
    controlsShown: controlsShown,
    setControlsShown: setControlsShown
  }))), props.description && /*#__PURE__*/React.createElement(ErrorBoundary, {
    type: "itemDescriptionComponent"
  }, /*#__PURE__*/React.createElement(ItemDescriptionComponent, {
    description: props.description,
    style: getViewStyles(readerOptions.itemDescriptionStyle, {
      marginTop: props.title ? defaultStyles.spacing : 0,
      paddingHorizontal: defaultStyles.spacing
    }, disableDefaultStyles)
  }, /*#__PURE__*/React.createElement(ErrorBoundary, {
    type: "the description"
  }, typeof props.description === "string" ? /*#__PURE__*/React.createElement(Typography, {
    size: TypographySize.Small,
    style: readerOptions.headerDescriptionTextStyle,
    disableDefaultStyles: disableDefaultStyles
  }, textParser(props.description, {
    type: "description",
    screen: "reader",
    scope: "item",
    style: readerOptions.headerSubtitleTextStyle
  })) : props.description))), /*#__PURE__*/React.createElement(ReaderControls, {
    props: propsFromItem,
    updateProp: updatePropFromItem,
    shown: controlsShown,
    setShown: setControlsShown,
    parent: "item"
  }), /*#__PURE__*/React.createElement(ErrorBoundary, {
    type: "itemComponentWrapper"
  }, /*#__PURE__*/React.createElement(ItemComponentWrapper, {
    style: getViewStyles([readerOptions.itemComponentStyle, props.wrapperStyle], {
      marginTop: props.title || props.description ? defaultStyles.spacing : 0,
      paddingHorizontal: defaultStyles.spacing
    }, disableDefaultStyles)
  }, /*#__PURE__*/React.createElement(ErrorBoundary, {
    type: "the component"
  }, /*#__PURE__*/React.createElement(props.Component, getPropsForComponent()))))));
});
ReaderItem.displayName = "ReaderItem";
//# sourceMappingURL=ReaderItem.component.js.map